import { ReactNode } from 'react';
import { FiUsers } from 'react-icons/fi';
import { StanTag } from '@/components/core-components/StanTag/StanTag';
import { FLOW_TRIGGER } from '../../constants';
import { LuMousePointerClick } from 'react-icons/lu';

interface AudienceTag {
    id?: string | number;
    name: string;
}

interface EditFlowSummarySectionProps {
    selectedTrigger: string;
    recipientCount: number;
    audienceTags: AudienceTag[];
    isDateTriggerActive: boolean;
}

interface SummaryItemProps {
    icon: ReactNode;
    label: string;
    value: ReactNode;
}

const SummaryItem = ({ icon, label, value }: SummaryItemProps) => (
    <div className='bg-neutral-subtle flex h-10 w-full items-center justify-between rounded-md p-2.5'>
        <div className='text-label-sm-bold text-gray flex items-center gap-1.5'>
            {icon}
            <span>{label}</span>
        </div>
        <div className='text-label-sm-bold text-dark'>{value}</div>
    </div>
);

const TRIGGER_TEXT_MAP: Record<string, string> = {
    [FLOW_TRIGGER.CHECKOUT]: 'After product purchase',
    [FLOW_TRIGGER.CART_ABANDONMENT]: 'After cart is abandoned',
    [FLOW_TRIGGER.TIME]: 'On a specific date',
};

export const EditFlowSummarySection = ({
    selectedTrigger,
    recipientCount,
    audienceTags,
    isDateTriggerActive,
}: EditFlowSummarySectionProps) => {
    const triggerText = TRIGGER_TEXT_MAP[selectedTrigger] || 'After product purchase';

    return (
        <div className='space-y-4'>
            <hr />
            <div className='flex flex-col gap-2'>
                <SummaryItem icon={<LuMousePointerClick className='size-4' />} label='Trigger' value={triggerText} />

                {recipientCount > 0 && (
                    <SummaryItem
                        icon={<FiUsers className='size-4' />}
                        label='Audience'
                        value={`${recipientCount.toLocaleString()} Recipients`}
                    />
                )}

                {isDateTriggerActive && audienceTags.length > 0 && (
                    <SummaryItem
                        icon={<FiUsers className='size-4' />}
                        label='Tags'
                        value={
                            <div className='flex flex-wrap gap-1'>
                                {audienceTags.map(tag => (
                                    <StanTag key={tag.id || tag.name} label={tag.name} className='bg-brand-dimmed' />
                                ))}
                            </div>
                        }
                    />
                )}
            </div>
        </div>
    );
};
